import { InformationAlertIcon } from "@/assets/images/svgIcons/informationAlertIcon"
import { Theme, useTheme } from "@/components/theme/themeProvider"
import type { TextVariants } from "@/components/ui/baseUi/text"
import { Text } from "@/components/ui/baseUi/text"
import { cn } from "@/modules/lib/utils"
import type { VariantProps } from "class-variance-authority"

type HUCardAlertProps = {
  title?: string
  description?: string
  icon?: React.ReactElement<React.SVGProps<SVGSVGElement>>
  titleFontStyle?: VariantProps<typeof TextVariants>["fontStyle"]
  descriptionFontStyle?: VariantProps<typeof TextVariants>["fontStyle"]
  className?: string
} & React.ComponentProps<"div">

export function HUCardAlert({
  title,
  description,
  icon,
  titleFontStyle = "BL",
  descriptionFontStyle = "BM",
  className,
  ...props
}: HUCardAlertProps) {
  const { theme } = useTheme()

  return (
    <div
      className={cn(
        "flex flex-row items-center gap-4 rounded-md border-l-5 border-l-primary-500 bg-surface-background-primary-information-secondary p-6 pl-4.5 [&_svg]:shrink-0",
        { "bg-primary-100/50": theme === Theme.OwnerDark },
        className,
      )}
      {...props}
    >
      {icon ? (
        icon
      ) : (
        <InformationAlertIcon
          width={48}
          height={48}
          className="shrink-0"
          backgroundColor="var(--interactive-background-primary-default)"
          color="var(--interactive-text-secondary-default)"
        />
      )}
      <div className="flex flex-col justify-evenly gap-2">
        {title && (
          <Text fontStyle={titleFontStyle} style={titleFontStyle === "BL" ? { lineHeight: "18px" } : undefined}>
            {title}
          </Text>
        )}
        {description && <Text fontStyle={descriptionFontStyle}>{description}</Text>}
      </div>
    </div>
  )
}
